<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
  
import { mapActions } from "vuex";
import Setting from "@/settings";
  export default {
    name: "App",
    provide(){
      return{
        reload:this.reload
      }
    },

    data(){
      return{
        isRouterAlive:true
      }
    },
    mounted(){
      console.log("app.vue.wws");
      this.refLoadFontWoff();
    },
    methods:{
        reload(){
          this.isRouterAlive = false;
          this.$nextTick(function () {
            this.isRouterAlive = true;
          });
        },
        // 有时f字体.woff文件不加载问题处理
        refLoadFontWoff() {
          console.log("refLoadFontWoff");
          var links = document.getElementsByTagName("link");
          Array.from(links).forEach(element => {
            if (element.href.indexOf("chunk-elementUI.") > 0) {
              var iHref = element.href + "?a=" + Date.now();
              element.href = iHref;
            }
          });

        }
    }
  };

</script>
<style>
 form.el-form{
    width:95%;
  }
  .el-dialog__header{
    padding-top:10px !important;
    padding-bottom:0px !important;
  }
  .el-dialog__body{
    padding: 20px 20px;
  }
  .el-dialog__footer{
    padding: 0px 20px 10px;
  }
</style>
